import './App.scss';
import Layout from './layout';
import './assets/scss/style.scss';
import { BrowserRouter } from 'react-router-dom';
import useAuthContext from './hooks/useAuthContext';
import Login from './pages/login';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ToasterProvider from './context/toasterContext';
import { useIsFetching } from 'react-query';
import { RetainmentProvider } from './context/retainmentContext';
import SignUp from './components/Signup';
import ApprovalPending from './components/Signup/ApprovalPending';

function App() {
    const { user, isAuthenticated } = useAuthContext();
    console.log('App', user);

    const GetSignUpFlowComponent = ({ signupStatus }) => {
        console.log(signupStatus);
        if (signupStatus == null || signupStatus == -1 || signupStatus == 2) {
            return <SignUp user={user} />;
        } else if (signupStatus == 1) {
            return (
                <ToasterProvider>
                    <Layout />
                </ToasterProvider>
            );
        } else if (signupStatus == 0) {
            return <ApprovalPending user={user} />;
        }
    };

    return (
        <>
            <ToastContainer />
            <RetainmentProvider>
                <BrowserRouter>{user ? <GetSignUpFlowComponent signupStatus={user?.signupStatus} /> : <Login />}</BrowserRouter>
            </RetainmentProvider>
        </>
    );
}

export default App;
